import type { WorkspaceWelcomeScreenConfig } from "@/types/workspaceWelcome";

export type WorkosUserProfileLike = {
  id: string;
  email: string;
  first_name?: string;
  last_name?: string;
  name?: string;
  display_name?: string;
  company_id: string;
  company_name?: string;
  role?: string;
  email_verified?: boolean;
  profile_picture_url?: string;
  last_login?: string;
  permissions?: string[];
  modules?: string[];
  sso_enabled?: boolean;
  welcome_screen?: WorkspaceWelcomeScreenConfig | null;
};

export type MappedAuthUser = {
  id: string;
  email: string;
  name: string;
  fullname?: string;
  image?: string;
  company_id: string;
  company_name?: string;
  role: string;
  permissions: string[];
  modules: string[];
  subscription_tier: string | null;
  created_at: string | null;
  updated_at: string | null;
  last_login: string | null;
  first_name?: string;
  last_name?: string;
  display_name?: string;
  email_verified?: boolean;
  profile_picture_url?: string;
  sso_enabled?: boolean;
  welcome_screen?: WorkspaceWelcomeScreenConfig | null;
};

export function resolveUserDisplayName(userProfile: WorkosUserProfileLike): string {
  const structured = [userProfile.first_name, userProfile.last_name]
    .map((part) => part?.trim())
    .filter(Boolean)
    .join(" ");
  if (structured) return structured;

  const displayName = userProfile.display_name?.trim();
  if (displayName) return displayName;

  const legacyName = userProfile.name?.trim();
  if (legacyName) return legacyName;

  return userProfile.email.split("@")[0];
}

export function mapWorkosUserProfile(userProfile: WorkosUserProfileLike): MappedAuthUser {
  const resolvedName = resolveUserDisplayName(userProfile);

  return {
    id: userProfile.id,
    email: userProfile.email,
    name: resolvedName,
    fullname: resolvedName,
    image: userProfile.profile_picture_url,
    company_id: userProfile.company_id,
    company_name: userProfile.company_name?.trim() || undefined,
    role: userProfile.role || "",
    permissions: userProfile.permissions || [],
    modules: userProfile.modules || [],
    subscription_tier: null,
    created_at: null,
    updated_at: null,
    last_login: userProfile.last_login || null,
    first_name: userProfile.first_name,
    last_name: userProfile.last_name,
    display_name: userProfile.display_name,
    email_verified: userProfile.email_verified,
    profile_picture_url: userProfile.profile_picture_url,
    sso_enabled: userProfile.sso_enabled === true,
    welcome_screen: userProfile.welcome_screen ?? null,
  };
}
